<script setup>
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientinputMedicationRow",
  });

  defineProps({
    medication: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  });

  defineEmits(["delete"]);
</script>

<template>
  <li class="flex flex-row items-center justify-between gap-5">
    <div>
      <div>{{ medication.Name }} / {{ medication.Packung }}</div>
      <p class="text-sm leading-tight text-gray-500">{{ medication.Anbieter }} / PZN: {{ medication.PZN }}</p>
    </div>

    <MedButton
      :aria-label="medication.Name ? `Medikament ${medication.Name} löschen` : 'Medikament löschen'"
      flat
      icon="delete"
      rounded="full"
      size="sm"
      :data-test="getTestId('medication-row-delete-button')"
      @click="$emit('delete', medication)"
    />
  </li>
</template>
